import React, { useState, useEffect, useContext } from 'react'
import send from "../Images/send.png"
import MessageBox from './MessageBox'
import ChatContext from '../Context/ChatContext';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-hot-toast';


function Chatspace({ socketRef, roomId, username }) {

  // const [messageList, setMessageList] = useState([]);
  const { message, messageList, setMessage, sendMessage, receiveMessage } = useContext(ChatContext)
  const [chatShow, setChatShow] = useState(false)

  function handleSendMessage() {
    // if(message===""){
    //   toast.error("please enter message");
    //   return
    // }
    sendMessage(socketRef.current, username, roomId, message);
    setMessage("");
  }
  function handleChatShow() {
    setChatShow(true)
  }
  useEffect(() => {
    receiveMessage(socketRef.current);
    // eslint-disable-next-line
  }, [socketRef.current])
  const handleEnterEvent = (e) => {
    if (e.code === "Enter" || e.code === "NumpadEnter") {
      // onJoinClick();
      sendMessage(socketRef.current, username, roomId, message);
      setMessage("");
    }
  }
  return (
    <>
      <section className={`${chatShow ? "" : "display-none"} chat `} >
        <header className="chat-header">
          <div className="chat-para">
            <h1>Chat Space</h1>
            {/* <p>Welcome!</p> */}
          </div>
          <div className="close-chat">
          <i className="fa-solid fa-2x fa-xmark" onClick={(e)=>{
            setChatShow(false)
          }}></i>
        </div>
        </header>
        
        <div className="chat-body">
          <div className="message-container">
            {
              messageList.map((msg,key) => {
                return <MessageBox key={uuidv4()} username={msg.username} message={msg.message} time={msg.time} type={msg.type} />
              })
            }
          </div>
        </div>
        <div className="chat-footer">
          <input required type="text" name="message" placeholder="Write a response... " onKeyUp={handleEnterEvent} value={message
          } onChange={(e) => setMessage(e.target.value)} />
          <img src={send} alt=""  onClick={handleSendMessage} />
        </div>
      </section>
      <div className={`chat-icon ${chatShow ? "display-none" : ""}`} onClick={handleChatShow} >
        <i className="fa-solid fa-2x fa-comments"></i>
      </div>
    </>
  )
}

export default Chatspace
